<template lang="pug">
    div
        v-list(dense)

            v-list-item(ripple link to="/")
                v-list-item-action
                    v-icon mdi-home
                v-list-item-content
                    v-list-item-title Home

            //- v-list-item(ripple link :href="railsVolieBaseUrl + '/call_screen'")
            //-     v-list-item-action
            //-         v-icon mdi-phone
            //-     v-list-item-content
            //-         v-list-item-title Call Screen

            v-list-item(ripple link to="/communication_center")
                v-list-item-action
                    v-icon mdi-headphones
                v-list-item-content
                    v-list-item-title Communication Center

            v-list-group(prepend-icon='mdi-poll' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Dashboard

                v-list-item(ripple link :to="{path: '/dashboards/affinity-dashboard'}")
                    v-list-item-title Affinity
                    v-list-item-action
                        v-icon mdi-link-variant

                v-list-item(ripple link :to="{path: '/dashboards/appointment-dashboard'}")
                    v-list-item-title Appointment
                    v-list-item-action
                        v-icon mdi-calendar-month

                v-list-item(ripple link :to="{path: '/dashboards/big-board'}")
                    v-list-item-title Big Board
                    v-list-item-action
                        v-icon mdi-view-dashboard

                v-list-item(ripple link :to="{path: '/dashboards/lead-dashboard'}")
                    v-list-item-title Lead
                    v-list-item-action
                        v-icon mdi-folder-account

                v-list-item(ripple link :to="{path: '/dashboards/live-dashboard'}")
                    v-list-item-title Live
                    v-list-item-action
                        v-icon mdi-sync

            v-list-group(prepend-icon='mdi-cog' no-action style="color: var(--white) !important;")
                template(v-slot:activator)
                    v-list-item-content(style="height: 48px;")
                        v-list-item-title Management

                //- v-list-item(ripple link to="/agent_visibility")
                //-     v-list-item-title Agent Visibility
                //-     v-list-item-action
                //-         v-icon mdi-account-group

                v-list-item(ripple link :href="railsVolieBaseUrl + '/appointments'")
                    v-list-item-title Appointments
                    v-list-item-action
                        v-icon mdi-calendar-month

                v-list-item(ripple link to="/calls")
                    v-list-item-title Calls
                    v-list-item-action
                        v-icon mdi-phone

                v-list-item(ripple link to="/campaign_deployments")
                    v-list-item-title Campaign Deployments
                    v-list-item-action
                        v-icon mdi-rocket-launch

                v-list-item(ripple link to="/customer_search")
                    v-list-item-title Customers
                    v-list-item-action
                        v-icon mdi-account-group

                v-list-item(v-if="showWorkplansNav" ripple link :href="workplansFrontendUrl" rel="noopener noreferrer")
                    v-list-item-title Workplan
                    v-list-item-action
                        v-icon mdi-list-box-outline

            v-list-item(ripple link to="/organizations")
                v-list-item-action
                    v-icon mdi-office-building
                v-list-item-content
                    v-list-item-title Organizations

            v-list-item(ripple link :href="pulseV2BaseUrl")
                v-list-item-action
                    PulseColorIcon(:size="35" style="margin-left: -4px")
                v-list-item-content(style="margin-left: -6px")
                    v-list-item-title Pulse

            v-list-item(ripple link to="/reports")
                v-list-item-action
                    v-icon mdi-folder-open
                v-list-item-content
                    v-list-item-title Reports

        v-divider

        v-list(dense)
            v-list-item(ripple :to="`/users/${currentUser.user_key}/edit`")
                v-list-item-action
                    v-icon mdi-account
                v-list-item-content
                    v-list-item-title Profile

            v-list-item(ripple link :href="'/api_docs'")
                v-list-item-action
                    v-icon mdi-notebook
                v-list-item-content
                    v-list-item-title Api Docs

            v-list-item(ripple link href="https://intercom.help/volie/en" target="_blank")
                v-list-item-action
                    v-icon mdi-help-circle
                v-list-item-content
                    v-list-item-title Help

            //- v-list-item(ripple link to="/privacy_policy")
            //-     v-list-item-action
            //-         v-icon mdi-security
            //-     v-list-item-content
            //-         v-list-item-title Privacy Policy

            //- v-list-item(ripple link to="/terms_and_conditions")
            //-     v-list-item-action
            //-         v-icon mdi-clipboard-text
            //-     v-list-item-content
            //-         v-list-item-title Terms and Conditions

            v-list-item(ripple link :href="railsVolieBaseUrl + '/log_out'")
                v-list-item-action
                    v-icon mdi-logout
                v-list-item-content
                    v-list-item-title Logout

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';
    import { CheckFeatureFlag } from '@/data/feature_flag_check';
    import { FeatureFlags } from '@/constants/feature_flags';

    import PulseColorIcon from '@/components/scorecards/pulse_color_icon.vue';

    export default Vue.extend({
        data() {
            return {
                workplansManagementEnabled: false,
            }
        },
        methods: {
        },
        computed: {
            currentUser() {
                return VolieState.currentUser();
            },
            railsVolieBaseUrl() {
                return VolieState.baseRailsUrl();
            },
            pulseV2BaseUrl() {
                return VolieState.basePulseV2Url();
            },
            workplansFrontendUrl() {
                return this.pulseV2BaseUrl + '/workplan';
            },
            showWorkplansNav() {
                return this.workplansManagementEnabled && this.currentUser?.account?.workplans_enabled === true;
            },
        },
        components: {
            PulseColorIcon,
        },
        props: {
        },
        watch: {
            'currentUser.activated_account_id'() {
                CheckFeatureFlag(FeatureFlags.WorkplansNavLink).then(enabled => {
                    this.workplansManagementEnabled = enabled;
                });
            },
        },
        created() {
            CheckFeatureFlag(FeatureFlags.WorkplansNavLink).then(enabled => {
                this.workplansManagementEnabled = enabled;
            });
        },
    });
</script>

<style lang="scss" scoped>
    
</style>
